<template>
  <Collapse
    class="green-operation__assessment green-operation__green-fit-out"
  >
    <template #title>
      <HKLLeftRight>
        <span class="font-bold">{{ $t('tenancy.greenOperation.assessments.greenFitOut.title') }}</span>
        <HKLInputPoints
          v-model="points"
          :isEdit="false"
          v-if="!isEdit && canViewPoint"
        />
      </HKLLeftRight>
    </template>
    <template #content>
      <div>
        <HKLLeftRight class="green-operation__assessment-title">
          <div>
            <span class="font-bold">
              {{ $t('tenancy.greenOperation.assessments.greenFitOut.submission') }}
            </span>
            <span
              v-if="enableTenantProjectsFeature"
              class="underline pointer"
              @click="() => navToAllProjects()"
            >
              {{ $t('tenancy.greenOperation.assessments.greenFitOut.viewMore') }}
            </span>
          </div>
          <HKLInputPoints
            v-model="submission.point"
            :isEdit="isEdit"
            v-if="canViewPoint"
          />
        </HKLLeftRight>
        <template v-if="isTenant && tableAttrs.dataSource.length === 0">
          {{ $t('emptyValue') }}
        </template>
        <HKLTable
          v-else-if="tableAttrs.dataSource.length > 0"
          v-bind="tableAttrs"
        />
      </div>
    </template>
  </Collapse>
</template>

<script>
import lodash from 'lodash'
import { toRefs, reactive, computed, unref } from 'vue-demi'
import Collapse from '@/controls/Collapse.vue'
import HKLLeftRight from '@/controls/Layout/HKLLeftRight.vue'
import HKLTable from '@/controls/Table/HKLTable.vue'
import HKLInputPoints from '../components/HKLInputPoints.vue'
import { useStoreGetters } from '@/store/index'
import i18n from '@/utils/i18n'
import EventBus from '@/utils/eventBus'
import { tenantProjectTypes } from '@/utils/locale'
import { useGreenOperationAssessmentFormStatus, useTProjectWithCompletedGreenFitOuts } from '../hook'
import { GREEN_OPERATION_ASSESSMENT_TYPE } from '../consts'
import { useAssessmentForm } from './hook'
import { totalPoints } from './utils'
import { useGreenOperationPerms } from '../GreenOperationLetter.hook'

const ASSESSMENT_TYPE = GREEN_OPERATION_ASSESSMENT_TYPE.GREEN_FIT_OUT

export default {
  components: {
    Collapse,
    HKLLeftRight,
    HKLInputPoints,
    HKLTable,
  },
  setup () {
    const { enableTenantProjectsFeature } = useStoreGetters('regions', ['enableTenantProjectsFeature'])
    const { isEdit } = useGreenOperationAssessmentFormStatus()
    const { isTenant } = useStoreGetters('user', ['isTenant'])
    const { canViewPoint } = useGreenOperationPerms()

    const formMap = reactive({
      submission: useAssessmentForm(ASSESSMENT_TYPE, 'submission'),
    })
    const { data: greenFitOuts } = useTProjectWithCompletedGreenFitOuts()
    const tableAttrs = computed(() => ({
      dataSource: unref(greenFitOuts).map((item) => {
        return {
          premises: `${item.projectLocation.join(', ')} - ${item.description}`,
          floor: item.floors.join(', '),
          status: i18n.t('status.recognised'),
          year: item.greenFitoutSubmissions[0].completedDate,
        }
      }),
      columns: [{
        title: i18n.t('table.header.premises'),
        dataIndex: 'premises',
      }, {
        title: i18n.t('table.header.floor'),
        dataIndex: 'floor',
      }, {
        title: i18n.t('table.header.status'),
        dataIndex: 'status',
        render: (item) => item.toUpperCase(),
      }, {
        title: i18n.t('table.header.year'),
        dataIndex: 'year',
        onSorter: (obj, _, list) => {
          return lodash.orderBy(list, ['raw.year'], [obj[1]])
        },
        render: (val) => new Date(val).getFullYear(),
      }],
      sort: ['year', 'desc'],
    }))
    return {
      isEdit,
      isTenant,
      canViewPoint,
      enableTenantProjectsFeature,
      ...toRefs(formMap),
      points: computed(() => totalPoints(formMap)),
      tableAttrs,
      navToAllProjects () {
        EventBus.emit('common-tabs-container-select-tab', `#tab-${2}`, 2)
        setTimeout(() => {
          EventBus.emit('tenancy.allProjectsTab.query', {
            project: {
              type: tenantProjectTypes.Fitout,
            },
          })
        }, 250)
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import './common.scss';

</style>
